import React from 'react';
import styled from 'styled-components';

const TermsWrapper = styled.section`
  padding: 50px 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const TermsTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
`;

const TermsText = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
`;

const TermsOfService = () => (
  <TermsWrapper>
    <TermsTitle>Terms of Service</TermsTitle>
    <TermsText>
      <strong>1. Introduction</strong><br />
      Welcome to Cloudetica Solutions. These Terms of Service ("Terms") govern your access to and use of our website and services. By accessing or using our services, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you should not use our services.

      <br /><br />
      <strong>2. Services</strong><br />
      Cloudetica Solutions provides cloud consulting services, including but not limited to, advisory, implementation, and support services for AWS, Azure, and Google Cloud. The scope of services will be outlined in a separate agreement or statement of work ("SOW") provided at the time of engagement.

      <br /><br />
      <strong>3. Client Responsibilities</strong><br />
      You agree to provide accurate, complete, and timely information necessary for us to deliver the services. You are responsible for ensuring that your use of our services complies with all applicable laws and regulations.

      <br /><br />
      <strong>4. Fees and Payment</strong><br />
      All fees for services will be outlined in the SOW or other agreement. Payments are due as specified in the agreement, and late payments may incur interest at a rate of 1.5% per month. Cloudetica Solutions reserves the right to suspend services for non-payment.

      <br /><br />
      <strong>5. Confidentiality</strong><br />
      Both parties agree to maintain the confidentiality of all proprietary or confidential information disclosed during the course of the engagement. This obligation continues beyond the termination of the agreement.

      <br /><br />
      <strong>6. Intellectual Property</strong><br />
      All intellectual property rights related to the services provided, including any work products, are owned by Cloudetica Solutions unless otherwise specified in the agreement. You are granted a limited, non-exclusive, non-transferable license to use the deliverables for your internal business purposes.

      <br /><br />
      <strong>7. Limitation of Liability</strong><br />
      To the maximum extent permitted by law, Cloudetica Solutions will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.

      <br /><br />
      <strong>8. Termination</strong><br />
      Either party may terminate the agreement by providing written notice in accordance with the terms specified in the SOW or other agreement. Upon termination, you agree to pay for all services provided up to the date of termination.

      <br /><br />
      <strong>9. Governing Law</strong><br />
      These Terms and any disputes arising out of or related to them or our services will be governed by and construed in accordance with the laws of the State of Victoria, Australia, without regard to its conflict of law principles.

      <br /><br />
      <strong>10. Amendments</strong><br />
      Cloudetica Solutions reserves the right to update or modify these Terms at any time. Any changes will be effective immediately upon posting to our website. Your continued use of our services after any changes constitutes your acceptance of the new Terms.

      <br /><br />
      <strong>11. Contact Information</strong><br />
      If you have any questions about these Terms, please contact us at:
      <br />
      Email: agung@cloudetica.com
    </TermsText>
  </TermsWrapper>
);

export default TermsOfService;
